import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCustomerGroupsPaginatedQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomerGroupDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomerGroupDocumentSortInput> | Types.CustomerGroupDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomerGroupsPaginatedQuery = { __typename?: 'Query', customerGroups?: { __typename?: 'CustomerGroupsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerGroupDocument', id: string, customerGroupId: string, name: string, status: Types.CustomerGroupStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerGroupQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomerGroupDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomerGroupQuery = { __typename?: 'Query', customerGroups?: { __typename?: 'CustomerGroupsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerGroupDocument', customerGroupId: string, name: string, status: Types.CustomerGroupStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerGroupMembersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CustomersSummaryDocumentSortInput> | Types.CustomersSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomerGroupMembersQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type AddCustomerGroupMutationVariables = Types.Exact<{
  input: Types.AddCustomerGroupInput;
}>;


export type AddCustomerGroupMutation = { __typename?: 'Mutation', addCustomerGroup: { __typename?: 'CustomerGroupPayload', customerGroup?: { __typename?: 'CustomerGroupStateData', customerGroupId: string, name: string, status: Types.CustomerGroupStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateCustomerGroupMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerGroupInput;
}>;


export type UpdateCustomerGroupMutation = { __typename?: 'Mutation', updateCustomerGroup: { __typename?: 'CustomerGroupPayload', customerGroup?: { __typename?: 'CustomerGroupStateData', customerGroupId: string, name: string, status: Types.CustomerGroupStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateCustomerGroupMutationVariables = Types.Exact<{
  input: Types.ActivateCustomerGroupInput;
}>;


export type ActivateCustomerGroupMutation = { __typename?: 'Mutation', activateCustomerGroup: { __typename?: 'CustomerGroupPayload', customerGroup?: { __typename?: 'CustomerGroupStateData', customerGroupId: string, name: string, status: Types.CustomerGroupStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateCustomerGroupMutationVariables = Types.Exact<{
  input: Types.DeactivateCustomerGroupInput;
}>;


export type DeactivateCustomerGroupMutation = { __typename?: 'Mutation', deactivateCustomerGroup: { __typename?: 'CustomerGroupPayload', customerGroup?: { __typename?: 'CustomerGroupStateData', customerGroupId: string, name: string, status: Types.CustomerGroupStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteCustomerGroupMutationVariables = Types.Exact<{
  input: Types.DeleteCustomerGroupInput;
}>;


export type DeleteCustomerGroupMutation = { __typename?: 'Mutation', deleteCustomerGroup: { __typename?: 'CustomerGroupPayload', customerGroup?: { __typename?: 'CustomerGroupStateData', customerGroupId: string, name: string, status: Types.CustomerGroupStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CustomerGroupFragment = { __typename?: 'CustomerGroupStateData', customerGroupId: string, name: string, status: Types.CustomerGroupStatus };

export const CustomerGroupFragmentDoc = new TypedDocumentString(`
    fragment CustomerGroup on CustomerGroupStateData {
  customerGroupId
  name
  status
}
    `, {"fragmentName":"CustomerGroup"});
export const GetCustomerGroupsPaginatedDocument = new TypedDocumentString(`
    query GetCustomerGroupsPaginated($where: CustomerGroupDocumentFilterInput, $order: [CustomerGroupDocumentSortInput!], $first: Int, $after: String) {
  customerGroups(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      id
      customerGroupId
      name
      status
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerGroupDocument = new TypedDocumentString(`
    query GetCustomerGroup($where: CustomerGroupDocumentFilterInput, $first: Int) {
  customerGroups(where: $where, first: $first) {
    nodes {
      customerGroupId
      name
      status
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerGroupMembersDocument = new TypedDocumentString(`
    query GetCustomerGroupMembers($where: CustomersSummaryDocumentFilterInput, $order: [CustomersSummaryDocumentSortInput!], $first: Int) {
  customers(where: $where, order: $order, first: $first) {
    nodes {
      customerId
      name
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const AddCustomerGroupDocument = new TypedDocumentString(`
    mutation AddCustomerGroup($input: AddCustomerGroupInput!) {
  addCustomerGroup(input: $input) {
    customerGroup {
      ...CustomerGroup
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerGroup on CustomerGroupStateData {
  customerGroupId
  name
  status
}`);
export const UpdateCustomerGroupDocument = new TypedDocumentString(`
    mutation UpdateCustomerGroup($input: UpdateCustomerGroupInput!) {
  updateCustomerGroup(input: $input) {
    customerGroup {
      ...CustomerGroup
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerGroup on CustomerGroupStateData {
  customerGroupId
  name
  status
}`);
export const ActivateCustomerGroupDocument = new TypedDocumentString(`
    mutation ActivateCustomerGroup($input: ActivateCustomerGroupInput!) {
  activateCustomerGroup(input: $input) {
    customerGroup {
      ...CustomerGroup
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerGroup on CustomerGroupStateData {
  customerGroupId
  name
  status
}`);
export const DeactivateCustomerGroupDocument = new TypedDocumentString(`
    mutation DeactivateCustomerGroup($input: DeactivateCustomerGroupInput!) {
  deactivateCustomerGroup(input: $input) {
    customerGroup {
      ...CustomerGroup
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerGroup on CustomerGroupStateData {
  customerGroupId
  name
  status
}`);
export const DeleteCustomerGroupDocument = new TypedDocumentString(`
    mutation DeleteCustomerGroup($input: DeleteCustomerGroupInput!) {
  deleteCustomerGroup(input: $input) {
    customerGroup {
      ...CustomerGroup
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerGroup on CustomerGroupStateData {
  customerGroupId
  name
  status
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerGroupsPaginated: build.query<GetCustomerGroupsPaginatedQuery, GetCustomerGroupsPaginatedQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerGroupsPaginatedDocument, variables })
    }),
    GetCustomerGroup: build.query<GetCustomerGroupQuery, GetCustomerGroupQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerGroupDocument, variables })
    }),
    GetCustomerGroupMembers: build.query<GetCustomerGroupMembersQuery, GetCustomerGroupMembersQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerGroupMembersDocument, variables })
    }),
    AddCustomerGroup: build.mutation<AddCustomerGroupMutation, AddCustomerGroupMutationVariables>({
      query: (variables) => ({ document: AddCustomerGroupDocument, variables })
    }),
    UpdateCustomerGroup: build.mutation<UpdateCustomerGroupMutation, UpdateCustomerGroupMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerGroupDocument, variables })
    }),
    ActivateCustomerGroup: build.mutation<ActivateCustomerGroupMutation, ActivateCustomerGroupMutationVariables>({
      query: (variables) => ({ document: ActivateCustomerGroupDocument, variables })
    }),
    DeactivateCustomerGroup: build.mutation<DeactivateCustomerGroupMutation, DeactivateCustomerGroupMutationVariables>({
      query: (variables) => ({ document: DeactivateCustomerGroupDocument, variables })
    }),
    DeleteCustomerGroup: build.mutation<DeleteCustomerGroupMutation, DeleteCustomerGroupMutationVariables>({
      query: (variables) => ({ document: DeleteCustomerGroupDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerGroupsPaginatedQuery, useLazyGetCustomerGroupsPaginatedQuery, useGetCustomerGroupQuery, useLazyGetCustomerGroupQuery, useGetCustomerGroupMembersQuery, useLazyGetCustomerGroupMembersQuery, useAddCustomerGroupMutation, useUpdateCustomerGroupMutation, useActivateCustomerGroupMutation, useDeactivateCustomerGroupMutation, useDeleteCustomerGroupMutation } = injectedRtkApi;
